import * as React from 'react';
import clsx from 'clsx';

import { withStyles, WithStyles } from '@nelnet/unifi-components-react';

import AppBar from './AppBar';
import NavDrawer from './NavDrawer';
import PageContent from './PageContent';
import SkipLink from '../../modules/SkipLink';

import styles from './styles/framestyles';
import HomeHero from '../Content/HomeHero';

// Google Analytics incorporation
import ReactGA from 'react-ga';
ReactGA.initialize('UA-177024637-3');
ReactGA.pageview(
  typeof window !== 'undefined' ? window.location.pathname + window.location.search : '',
);

interface ILayoutFrameProps extends WithStyles<typeof styles> {
  title: string;
  path: string;
}

const LayoutFrame: React.FunctionComponent<ILayoutFrameProps> = ({
  title,
  path,
  classes,
  children,
}) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setMobileOpen(true);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  const rootHome = path === '' ? classes.rootHome : '';

  const slashit = path.charAt(path.length - 1) !== '/' ? '/' : '';
  const slug = `${path}${slashit}`;

  return (
    <>
      <SkipLink />
      <div className={clsx(classes.root, rootHome)}>
        {path !== '' && <AppBar {...{ title, path, onOpen: handleDrawerOpen }} />}
        <NavDrawer
          className={classes.drawer}
          disablePermanent={false}
          onClose={handleDrawerClose}
          onOpen={handleDrawerOpen}
          mobileOpen={mobileOpen}
          activePage={title}
          activePath={slug}
        />
        {path === '' && <HomeHero />}
        <PageContent path={path}>{children}</PageContent>
      </div>
    </>
  );
};

export default withStyles(styles)(LayoutFrame);
